module.exports = __webpack_public_path__ + "img/fauteuil-19.c008c870.jpg";